module.exports = __webpack_public_path__ + "static/image/DELIVERY.svg?7a59e7d82bf3c392d4f2ed9e390bd3d7";